// extracted by mini-css-extract-plugin
export default {"info-container":"ThemHinhAnhDetail_info-container__paIuB","title":"ThemHinhAnhDetail_title__2bFSK","btn-container":"ThemHinhAnhDetail_btn-container__Hj1sz"};